<template>
  <div class="home-layout">
    <AppSidebar />
    <main class="main-content" :class="{ 'sidebar-open': isSidebarOpen }">
      <button @click="toggleSidebar" class="hamburger-menu" :class="{ 'is-hidden': isSidebarOpen }">
        <i class="pi pi-bars"></i>
      </button>
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import AppSidebar from '../components/AppSidebar.vue';
import { useUIStore } from '../stores/ui';

const uiStore = useUIStore();
const isSidebarOpen = computed(() => uiStore.isSidebarOpen);

const toggleSidebar = () => {
  uiStore.toggleSidebar();
};
</script>

<style scoped>
.home-layout {
  display: flex;
  height: 100vh;
  background-color: var(--bg-color);
  transition: padding-left 0.3s ease-in-out;
}

.main-content {
  flex-grow: 1;
  overflow-y: auto;
  padding: 0;
  transition: padding-left 0.3s ease-in-out;
}

.hamburger-menu {
  display: none;
  position: fixed;
  top: 1.5rem;
  left: 1.5rem;
  z-index: 101; /* Higher than sidebar */
  background: white;
  color: var(--p-text-color);
  border: 1px solid black;
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  font-size: 1.5rem;
}

.hamburger-menu.is-hidden {
  display: none;
}

/* Responsive Styles */
@media (min-width: 768px) {
  .main-content {
    padding-left: 250px; /* Same as sidebar width */
  }
}

@media (max-width: 767px) {
  .hamburger-menu {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-content.sidebar-open {
    /* Optional: could add a slight push if needed */
    /* padding-left: 250px; */
  }
}
</style>
